
define('template!threadsThreadReplyView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="reply-header">Reply</div>\n<div class="reply-fields">\n    <div class="field-row reply-from-row" hidden>\n        <label>From:</label>\n        <select class="reply-from" title="Send from"></select>\n    </div>\n    <div class="field-row">\n        <label>To:</label>\n        <input type="text" class="reply-to" value="' +
((__t = ( replyTo )) == null ? '' : __t) +
'" />\n    </div>\n    <div class="field-row">\n        <label>Cc:</label>\n        <input type="text" class="reply-cc" value="' +
((__t = ( replyCc )) == null ? '' : __t) +
'" />\n    </div>\n</div>\n<div class="reply-body">\n    <textarea class="reply-message" placeholder="Write your reply..."></textarea>\n</div>\n<div class="attachments-region"></div>\n<div class="reply-actions">\n    <button type="button" class="btn-signature">Insert signature</button>\n    <button class="btn-send">Send</button>\n</div>\n';

}
return __p
};});

